export const routes = (prefix = `outpatient`) => [
    {
        path: `/${prefix}/list`,
        name: `${prefix}.outpatient-list.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.outpatient-list.index`,
                PageDescription: "Outpatient: Outpatient list",
            },
        },
    },
];
